export function arrayOrEmpty<T>(array: Array<T> | undefined | null): Array<T> {
    return array || [];
}